import isEmpty from 'lodash/isEmpty';
import each from 'lodash/each';
import find from 'lodash/find';
import some from 'lodash/some';
import findIndex from 'lodash/findIndex';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import join from 'lodash/join';
import includes from 'lodash/includes';
import User from 'yoda-site-components/lib/helpers/User/User';
import {
    getOrderShippingType,
    getCurbsideEligible,
    getDataForOOS,
    convertMillisecondsToCT,
    getDataForB2BAgentMktItem,
} from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import {
    ANALYTICS_LOCAL_STORAGE_KEY_CART_TOTAL,
    ANALYTICS_SUB_TOTAL,
    ADJUSTMENT_TYPE_FREE_SHIP,
    ADJUSTMENT_TYPE_SHIPPING,
    ADJUSTMENT_TYPE_COUPON,
    ADJUSTMENT_TYPE_REWARD,
    ADJUSTMENT_TYPE_ASSOC_DISCOUNT,
    DOLLAROFF,
    PERCENTOFF,
    CHARGE_TYPE_SHIPPING_AND_HANDLING,
    SHIPPING_GROUP_TYPE_HOME,
    shippingDeliveryType,
    certonaRecommendationsCart,
    certonaRecommendationsEmptyCart,
    PLCC_DYN_BANNER_APPLY_AND_BUY_CODE,
    PLCC_DYN_BANNER_CODES,
    ADJUSTMENT_TYPE_ENTERPRISE,
    COUPON_SUB_TYPE_PROMOTIONAL,
} from 'yoda-checkout-components/lib/common/Constants';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { updateStoreOnCartAction } from 'yoda-site-components/lib/actions/LocationServiceAction';
import {
    setOosDetails,
    resetOosDetails,
    resetB2bAgentMktItemDetails,
    setB2BAgentMktItemDetails,
} from 'yoda-checkout-components/lib/actions/OutOfStockActions';
import {
    updateCouponNudgeAlert,
    updateLowStockNudgeAlertItem,
} from 'yoda-checkout-components/lib/actions/NudgeAlertAction';
import filter from 'lodash/filter';
import CartService from '../services/CartService';
import { getOrderInfo } from '../actions/OrderInfoAction';
import { getOrderTotals } from '../actions/OrderTotalsAction';
import { getCartItems } from '../actions/CartItemsAction';
import { getOrderAdjustments } from '../actions/OrderAdjustmentsAction';
import { getOrderCharges } from '../actions/OrderChargesAction';
import { getOrderRewards } from '../actions/OrderRewardsAction';
import { getCertonaAttributes } from '../actions/CertonaAttributesAction';
import { setPlccDynamicBanner } from '../actions/PlccDynamicBannerAction';

const defaultAction = {
    type: 'FETCHING_DATA',
    payload: {},
};

export default class CartDetailsModel {
    constructor(orderDetailsResponse) {
        this.orderDetailsAPIResponse = orderDetailsResponse;
        const { data } = orderDetailsResponse;
        this.orderDetails = data;
        this.defaultAction = {
            type: 'FETCHING_DATA',
            payload: {},
        };
        if (!isEmpty(data)) {
            this.number = data.number;
            this.billing = data.billing;
            this.href = data.href;
            this.id = data.id;
            this.status = data.status;
            this.submittedDate = data.submittedDate;
            this.country = data.country;
            this.currency = data.currency;
            this.freeShippingThreshold = data.freeShippingThreshold;
            this.amountShortForShippingDiscount = data.amountShortForShippingDiscount;
            this.contact = data.contact;
            this.totals = data.totals;
            this.isPriceAccurate = data.isPriceAccurate;
            this.delivery = data.delivery;
            this.bag = data.bag;
            this.adjustments = data.adjustments;
            this.giftWraps = data.giftWraps;
            this.charges = data.charges;
            this.altCharges = data.altCharges;
            this.banners = data.banners;
            this.checkedStoreId = data.checkedStoreId;
            this.charity = data.charity;
            this.shippingProtection = data.shippingProtection;
            this.deliveryChangedItems = data.deliveryChangedItems;
            this.isJcpCardInOrder = CartService.isJcpCardInOrder(
                get(data, 'metadata.cardTypeIndicator', '')
            );
        }
    }

    getOrderInfo(context) {
        if (isEmpty(this.orderDetails)) {
            return defaultAction;
        }
        const orderInfo = {
            orderId: this.number,
            href: this.href,
            id: this.id,
            number: this.number,
            status: this.status,
            submittedDate: this.submittedDate,
            country: this.country,
            currency: this.currency,
            itemsCount: this.bag.itemCount,
            shippingGroups: this.delivery.groups,
            billingInfo: this.billing,
            freeShippingThreshold: this.freeShippingThreshold,
            amountShortForShippingDiscount: this.amountShortForShippingDiscount,
            isPriceAccurate: this.isPriceAccurate,
            banners: this.banners,
            checkedStoreId: this.checkedStoreId,
            roundUpCharityEnabled: !isEmpty(this.charity),
            isRoundUpCharitySelected: !isEmpty(this.charity) && this.charity.selected,
            // shippingProtectionEligible: !isEmpty(this.charity),
            // shippingProtectionSelected: !isEmpty(this.charity) && this.charity.selected,
            // shippingProtectionAmount: 4,
            shippingProtectionEligible: !isEmpty(this.shippingProtection),
            shippingProtectionSelected:
                !isEmpty(this.shippingProtection) && this.shippingProtection?.selected,
            shippingProtectionAmount:
                !isEmpty(this.shippingProtection) && this.shippingProtection?.amount,
            isJcpCardInOrder: this.isJcpCardInOrder,
            deliveryChangedItemsData: CartService.getDeliveryChangedItems(
                this.bag.items,
                this.deliveryChangedItems
            ),
        };
        const orderShippingType = getOrderShippingType(this.delivery.groups || []);
        if (orderShippingType) {
            orderInfo.orderShippingType = orderShippingType;
        }
        const enableCurbsideBanner = get(context, 'featureFlags.enableCurbsideBanner', true);
        if (enableCurbsideBanner) {
            orderInfo.showCurbsideBanner = getCurbsideEligible(this.bag.items, 'cart');
        }
        return getOrderInfo(orderInfo);
    }

    getOrderTotals() {
        if (isEmpty(this.orderDetails)) {
            return defaultAction;
        }
        const orderTotals = {};
        /* istanbul ignore else  */
        if (this.orderDetails && this.totals) {
            each(this.totals, (total) => {
                orderTotals[`${total.type}`] = total.amount;
                total.type === ANALYTICS_SUB_TOTAL
                    ? LocalStorage.setData(ANALYTICS_LOCAL_STORAGE_KEY_CART_TOTAL, total.amount)
                    : '';
            });
            !this.isPriceAccurate ? (orderTotals['ORDER AMOUNT'] = 'TBD') : '';
        }
        return getOrderTotals(orderTotals);
    }

    getCartItems() {
        if (isEmpty(this.orderDetails)) {
            return defaultAction;
        }

        const { deliveryChangedItems } = this;
        /* istanbul ignore else */
        if (!isEmpty(deliveryChangedItems)) {
            each(this.bag.items, (lineItem) => {
                const item = lineItem;
                if (includes(deliveryChangedItems, item.id)) {
                    item.deliveryMethodChanged = true;
                }
            });
        }

        return getCartItems(this.bag.items);
    }

    getOrderAdjustments() {
        if (isEmpty(this.orderDetails)) {
            return defaultAction;
        }

        const adjustmentInfo = [];
        let rewardsCount = 0;
        let rewardsAmount = 0;
        let rewardsPresent = false;
        let rewardAdjustment = {};
        let rewardId;
        let rewardsMessage;
        /* istanbul ignore else  */
        if (this.orderDetails && this.adjustments) {
            // Please do not disturb the sequence. It is used for front end display purpose.
            // Sequence 1: Rewards
            each(this.adjustments, (adjustment) => {
                if (adjustment.code === ADJUSTMENT_TYPE_REWARD) {
                    rewardsPresent = true;
                    rewardsCount += 1;
                    rewardsAmount += adjustment.amount;
                    rewardId = adjustment.id;
                    rewardsMessage = adjustment.message;
                }
            });
            /* istanbul ignore else  */
            if (rewardsPresent) {
                rewardAdjustment = {
                    amount: rewardsAmount,
                    code: ADJUSTMENT_TYPE_REWARD,
                    value: 'Reward',
                    count: rewardsCount,
                    message: rewardsMessage,
                };
                rewardsCount === 1 ? (rewardAdjustment.id = rewardId) : null;
                adjustmentInfo.push(rewardAdjustment);
            }

            // Sequence 2: Coupons
            each(this.adjustments, (adjustment) => {
                if (
                    adjustment.code !== ADJUSTMENT_TYPE_REWARD &&
                    adjustment.code !== ADJUSTMENT_TYPE_ASSOC_DISCOUNT
                ) {
                    adjustmentInfo.push(adjustment);
                }
            });

            // Sequence 3: Associate Discount
            const assocAdjustment = find(this.adjustments, {
                code: ADJUSTMENT_TYPE_ASSOC_DISCOUNT,
            });
            if (assocAdjustment) {
                assocAdjustment.value = 'Assoc. Discount';
                adjustmentInfo.push(assocAdjustment);
            }

            // Sequence 4: Shipping Discount
            const shippingAdjustment = find(
                this.adjustments,
                (shippingAdjustments) =>
                    shippingAdjustments.code === ADJUSTMENT_TYPE_SHIPPING &&
                    shippingAdjustments.subType === ADJUSTMENT_TYPE_SHIPPING
            );
            if (shippingAdjustment) {
                shippingAdjustment.code = ADJUSTMENT_TYPE_COUPON;
                shippingAdjustment.description = ADJUSTMENT_TYPE_FREE_SHIP;
                adjustmentInfo.push(shippingAdjustment);
            }
        }
        return getOrderAdjustments(adjustmentInfo);
    }

    getAppliedRewards() {
        if (isEmpty(this.orderDetails)) {
            return defaultAction;
        }

        const appliedRewardsArray = [];
        /* istanbul ignore else  */
        if (this.orderDetails && this.adjustments) {
            each(this.adjustments, (adjustment) => {
                if (adjustment.code === ADJUSTMENT_TYPE_REWARD) {
                    const rewardObject = {
                        id: adjustment.id,
                        issueDate: null,
                        expiryDate: null,
                        expiresIn: null,
                        dollarOff: adjustment.amountType === DOLLAROFF,
                        percentOff: adjustment.amountType === PERCENTOFF,
                        certValue:
                            adjustment.amountType === PERCENTOFF
                                ? adjustment.percentageOff
                                : adjustment.amount,
                        type: adjustment.value,
                        code: adjustment.value,
                        serialNumber: adjustment.serialNumber,
                        manualEntry: true,
                        applied: true,
                    };
                    appliedRewardsArray.push(rewardObject);
                }
            });
        }
        return getOrderRewards(appliedRewardsArray);
    }

    getOrderCharges() {
        if (isEmpty(this.orderDetails)) {
            return defaultAction;
        }
        const orderCharges = [];
        const cartItems = this.bag.items;
        const hasTruckableItem =
            find(cartItems, (item) => item.product.truckable === true) !== undefined;
        if (this.charges) {
            const deliveryChargeItem = find(this.charges, {
                type: CHARGE_TYPE_SHIPPING_AND_HANDLING,
            });
            const estimatedTax = find(this.charges, { name: 'estimated tax' });
            const estimatedSts = find(this.charges, { name: 'estimated ship to store' });

            if (deliveryChargeItem && deliveryChargeItem.name === 'estimated shipping & handling') {
                /* istanbul ignore else */
                if (!hasTruckableItem) {
                    deliveryChargeItem.name = 'Est. Standard Delivery';
                }
                if (hasTruckableItem) {
                    deliveryChargeItem.amount =
                        deliveryChargeItem.amount === 0 ? 'INCLUDED' : deliveryChargeItem.amount;
                    deliveryChargeItem.name = 'Est. Shipping & Handling';
                }
            }
            if (estimatedTax) {
                estimatedTax.name = 'tax';
                estimatedTax.type = 'TAX';
                estimatedTax.amount = 'TBD';
            }
            if (estimatedSts) {
                estimatedSts.name = 'Or Ship to Store';
            }

            /* istanbul ignore else  */
            let shippingCouponAdj = false;
            if (this.adjustments && deliveryChargeItem) {
                shippingCouponAdj = find(this.adjustments, {
                    description: ADJUSTMENT_TYPE_FREE_SHIP,
                });
                /* istanbul ignore else  */
                if (shippingCouponAdj) {
                    deliveryChargeItem.value = shippingCouponAdj.value;
                    deliveryChargeItem.isCouponNotApplied = shippingCouponAdj.amount === 0;
                }
            }
            /* istanbul ignore else  */
            if (this.delivery && this.delivery.groups && this.delivery.groups.length > 0) {
                // const deliverToStore = find(this.delivery.groups, { type: shippingGroupType.STORE });
                const deliverToStore = find(cartItems, (item) => {
                    const isSTSSelected = find(item.deliveryOptions, {
                        code: 'STORE',
                        selected: true,
                    });
                    return !isEmpty(isSTSSelected);
                });
                if (deliverToStore && deliveryChargeItem && !estimatedSts) {
                    // MCYODA-15710: If we have 'Or Ship to Store', then we should not change below name
                    deliveryChargeItem.name = 'Ship To Store';
                }

                const deliveryGroup = find(this.delivery.groups, {
                    type: SHIPPING_GROUP_TYPE_HOME,
                });
                if (deliveryGroup && !isEmpty(deliveryGroup.address)) {
                    /* istanbul ignore else  */
                    const serviceLevelsData = get(deliveryGroup, 'serviceLevels.data.length', 0);
                    if (serviceLevelsData > 0) {
                        const deliveryType = find(deliveryGroup.serviceLevels.data, {
                            selected: true,
                        });
                        /* istanbul ignore else */
                        if (
                            deliveryChargeItem &&
                            deliveryType &&
                            ((hasTruckableItem && deliveryType.code === 'TRUCK') ||
                                (!hasTruckableItem && deliveryType.code !== 'TRUCK'))
                        ) {
                            deliveryChargeItem.name = `${
                                shippingDeliveryType[deliveryType.code]
                            } Delivery`;
                        }
                    } else if (deliveryChargeItem) {
                        deliveryChargeItem.name = 'Standard Delivery';
                    }
                }
            }
            // this.charges.push({
            //     amount: 2.99,
            //     name: 'shipping protection',
            //     type: 'SHIPPING PROTECTION',
            // })
            each(this.charges, (chargeParam) => {
                const charge = chargeParam;
                !this.isPriceAccurate ? (charge.amount = 'TBD') : '';
                orderCharges.push(charge);
            });

            // Move tax to the end of charges
            const indexOfTax = findIndex(orderCharges, { type: 'TAX' });
            /* istanbul ignore else */
            if (indexOfTax > -1) {
                orderCharges.push(orderCharges.splice(indexOfTax, 1)[0]);
            }

            // Move round up to the end of charges
            const indexOfCharge = findIndex(orderCharges, { type: 'ROUND UP' });
            if (indexOfCharge > -1) {
                orderCharges.push(orderCharges.splice(indexOfCharge, 1)[0]);
            }

            // Move Shipping protection to the end of charges
            const indexOfProtection = findIndex(orderCharges, { type: 'SHIPPING PROTECTION' });
            if (indexOfProtection > -1) {
                orderCharges.push(orderCharges.splice(indexOfProtection, 1)[0]);
            }
        }
        return getOrderCharges(orderCharges);
    }

    getCertonaAttributes(enableSinglePPIDRecommendation, enableAnalyticsCartIds) {
        const attrMapIds = [];
        const cartIds = [];
        let itemsCount = enableSinglePPIDRecommendation ? this.bag.items.length : 0;
        if (!isEmpty(this.orderDetails) && !isEmpty(this.bag) && !isEmpty(this.bag.items)) {
            if (enableSinglePPIDRecommendation) {
                attrMapIds.push(this.bag.items[0].product.id);
            } else {
                each(this.bag.items, (item) => {
                    attrMapIds.push(item.product.id);
                    itemsCount += item.quantity;
                });
            }
            if (enableAnalyticsCartIds) {
                each(this.bag.items, (item) => {
                    cartIds.push(item.product.id);
                });
            }
        }

        const customerId = User.getUserId();
        const certonaAttributes =
            itemsCount > 0
                ? {
                      customerid: customerId,
                      recommendations: certonaRecommendationsCart,
                      itemid: join(attrMapIds, ';'),
                      cartIds: join(cartIds, ','),
                  }
                : {
                      // TODO: Test after the Cart API integration
                      customerid: customerId,
                      recommendations: certonaRecommendationsEmptyCart,
                      itemid: '',
                      cartIds: '',
                  };
        return getCertonaAttributes(certonaAttributes);
    }

    getCouponAlertInfo(nudegeAlertFeatureFlags, couponExpireNudgeTime) {
        const { enableCouponExpireNudgeAlert } = nudegeAlertFeatureFlags;
        if (isEmpty(this.orderDetails)) {
            return defaultAction;
        }
        if (enableCouponExpireNudgeAlert) {
            const couponsAboutToExpire = [];
            if (this.orderDetails && this?.adjustments) {
                each(this.adjustments, (adjustment) => {
                    if (
                        (adjustment.code === ADJUSTMENT_TYPE_COUPON ||
                            adjustment.code === ADJUSTMENT_TYPE_ENTERPRISE) &&
                        adjustment.subType === COUPON_SUB_TYPE_PROMOTIONAL &&
                        adjustment.amount !== 0
                    ) {
                        const currentTime = convertMillisecondsToCT(new Date().getTime());
                        const expiryTime = adjustment?.adjustmentExpiryDate;
                        const couponValidTIme = expiryTime - currentTime;
                        if (
                            expiryTime &&
                            couponValidTIme > 0 &&
                            couponValidTIme <= couponExpireNudgeTime * 60 * 60 * 1000
                        ) {
                            couponsAboutToExpire.unshift({ value: adjustment.value });
                        }
                    }
                });
            }
            return updateCouponNudgeAlert({ couponsAboutToExpire });
        }
        return { type: 'DISABLED_COUPON_NUDGE_ALERT', payload: {} };
    }

    getNudgeAlertInfo(nudegeAlertFeatureFlags) {
        const { enablelowStockNudgeAlert } = nudegeAlertFeatureFlags;
        if (isEmpty(this.orderDetails)) {
            return defaultAction;
        }
        if (enablelowStockNudgeAlert) {
            const lowStockItems = [];
            let lowStockQuantity = 0;
            if (this.orderDetails && this.bag?.items) {
                const bagItems = this.bag.items;
                each(bagItems, (item) => {
                    /** MCYODA-30489 - 2 or more than 2 items lowstock Nudge will render default image - so breaking loop */
                    if (lowStockQuantity >= 2) return;
                    const isUrgencyLabeled = find(
                        item.deliveryOptions,
                        (option) => option.selected && option.inventory?.urgency
                    );
                    if (isUrgencyLabeled || item.inventory.status === 'LIMITEDSTOCKAVAILABLE') {
                        lowStockItems.push({ imageURL: item?.product?.imageURL });
                        lowStockQuantity += 1;
                    }
                });
            }
            return updateLowStockNudgeAlertItem({ lowStockItems });
        }
        return { type: 'DISABLED_NUDGE_ALERT', payload: {} };
    }

    checkErrors() {
        if (isEmpty(this.orderDetails)) {
            return defaultAction;
        }

        let isAllItemsOOS = false;
        let isItemOOS = false;
        if (this.status && this.status.exceptions) {
            forEach(this.status.exceptions, (exception) => {
                if (
                    exception.code === 'ALL_ITEMS_OUT_OF_STOCK' ||
                    exception.errorCode === 'ALL_ITEMS_OUT_OF_STOCK'
                ) {
                    isAllItemsOOS = true;
                } else if (
                    exception.code === 'ORDER_HAS_OUT_OF_STOCK' ||
                    exception.errorCode === 'ORDER_HAS_OUT_OF_STOCK'
                ) {
                    isItemOOS = true;
                }
            });
        }
        if (isAllItemsOOS || isItemOOS) {
            const oosInfo = getDataForOOS(this.bag.items);
            return setOosDetails({ ...oosInfo });
        }
        return resetOosDetails();
    }

    discontinuedOOSErrors() {
        if (isEmpty(this.orderDetails)) {
            return defaultAction;
        }

        let isItemOOS = false;
        if (this.status && this.status.exceptions) {
            isItemOOS = some(
                this.status.exceptions,
                (exceptionsList) =>
                    exceptionsList.errorCode === 'CODE_FOR_DISCONTINUED_AND_OR_OOS_ITEMS' ||
                    exceptionsList.code === 'CODE_FOR_DISCONTINUED_AND_OR_OOS_ITEMS' ||
                    exceptionsList.errorCode === 'API_ERR_MKTPLC_ITEM_IN_B2B_ORDER' ||
                    exceptionsList.code === 'API_ERR_MKTPLC_ITEM_IN_B2B_ORDER'
            );
        }
        if (isItemOOS) {
            const oosInfo = getDataForOOS(this.bag.items);
            return setOosDetails({ ...oosInfo });
        }
        return resetOosDetails();
    }

    /* istanbul ignore else */
    checkB2bAgentMktErrors() {
        /** MCYODA-31152 - interim soultion for B2bAgent to restrict checkout of marketplaceitem */
        if (isEmpty(this.orderDetails)) {
            return defaultAction;
        }

        let isMktItem = [];
        if (this.status && this.status.exceptions) {
            isMktItem = filter(
                this.status.exceptions,
                (exceptionsList) =>
                    exceptionsList.errorCode === 'API_ERR_MKTPLC_ITEM_IN_B2B_ORDER' ||
                    exceptionsList.code === 'API_ERR_MKTPLC_ITEM_IN_B2B_ORDER'
            );
        }
        if (isMktItem.length > 0) {
            const mktItem = getDataForB2BAgentMktItem(
                this.bag.items,
                isMktItem[0]?.errorDescription
            );
            return setB2BAgentMktItemDetails({ ...mktItem });
        }
        return resetB2bAgentMktItemDetails();
    }

    setOrderBannerDetails() {
        let plccDynamicBanner = {
            displayPlccBanner: false,
            bannerHtml: '',
        };
        if (
            isEmpty(this.orderDetails) ||
            isEmpty(this.banners) ||
            this.banners[0].code === 'EMPTYCART'
        ) {
            return setPlccDynamicBanner(plccDynamicBanner);
        }
        const banner = this.banners[0];
        const { savings } = banner;
        const estSavings = savings ? savings.amount : undefined;
        const afterSavings = banner.total;
        const savingsPercentage = get(savings, 'percentage.max', undefined);
        const savingsMinPercentage = get(savings, 'percentage.min', undefined);
        let subTotal = !this.isPriceAccurate ? 'TBD' : 0;
        /* istanbul ignore else */
        if (!subTotal) {
            const temp = find(this.totals, (item) => item.type === 'ORDER AMOUNT');
            temp && (subTotal = temp.amount);
        }
        const displayPlccBanner = PLCC_DYN_BANNER_CODES.includes(banner.code);
        const isPromoFinancing = banner.code !== PLCC_DYN_BANNER_APPLY_AND_BUY_CODE;
        const contentLink = find(banner.links, (item) => item.rel === 'content');
        const detailsLink = find(banner.links, (item) => item.rel === 'details');
        plccDynamicBanner = {
            code: banner.code,
            estSavings,
            savingsPercentage,
            savingsMinPercentage,
            subTotal,
            afterSavings,
            displayPlccBanner,
            isPromoFinancing,
            contentLink,
            detailsLink,
            bannerUpdated: !__SERVER__ && displayPlccBanner,
        };
        return setPlccDynamicBanner(plccDynamicBanner);
    }

    updateUserStoreLocationInfo(userStoreInfo) {
        let isBopisSelected = '';
        const cartItems = this.bag.items;
        const isBopis = find(cartItems, (item) => {
            isBopisSelected = find(item.deliveryOptions, { code: 'BOPIS', selected: true });
            return !isEmpty(isBopisSelected);
        });
        const bopiStoreId = get(isBopisSelected, 'storeAddress.id', null);

        const storeId = get(userStoreInfo, 'storeId');
        if (isBopis && storeId && storeId !== bopiStoreId) {
            // updates AURORA store with user preferred store
            if (__SERVER__) {
                this.bag.reload = true;
                this.bag.syncStoreId = userStoreInfo.storeId;
            } else {
                return updateStoreOnCartAction(userStoreInfo.storeId);
            }
        }

        return defaultAction;
    }
}
